import { Link } from 'react-router-dom'

function BohemiaIdNav() {
  return (
    <Link to='/profile/identificacion' className="w-full" onClick={() => { gtag('event', 'event_to_ga', { event_category: 'navegacion_memorama', event_label: 'Home links' }) }}>
      <img src={`${AZURE_BASE_URL}/home-banner-id.webp`} alt='bohemia' className='w-full' />
    </Link>
  )
}

export default BohemiaIdNav